import gql from 'graphql-tag';

export const LIST_ALL_FREIGHT_REQUESTS = gql`
  query {
    freightRequests: listFreightRequests {
      freightRequestId
      details {
        layDate
        cancelling
      }
      company {
        companyName
      }
      cargo {
        cargoName
        quantity {
          unit
          amount
          tolerance
        }
      }
      routes {
        loadLocations {
          locationName
        }
        dischargeLocations {
          locationName
        }
        offer {
          offerAmount
          offerUnit
        }
      }
      ship {
        name
      }
      discussion {
        created
      }
      unreadMessages
      status
      modified
      created
    }
  }
`;
